var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRdetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66668 0.00183334V0H10.3877C10.725 0 11 0.278055 11 0.606221V11.616C10.9998 11.7768 10.9358 11.931 10.822 12.0447C10.7083 12.1584 10.554 12.2222 10.3932 12.2222H0.606848C0.526595 12.2216 0.447238 12.2053 0.373309 12.1741C0.29938 12.1428 0.232326 12.0973 0.175976 12.0402C0.119626 11.9831 0.0750835 11.9154 0.044892 11.841C0.0147005 11.7666 -0.000548657 11.6871 1.50779e-05 11.6068V3.66666L3.66668 0.00183334ZM1.72946 3.66666H3.66668V1.72944L1.72946 3.66666ZM4.8889 1.22222V4.27777C4.8889 4.43985 4.82451 4.59529 4.70991 4.70989C4.5953 4.8245 4.43986 4.88888 4.27779 4.88888H1.22224V11H9.77778V1.22222H4.8889ZM3 6H8V7H3V6ZM8 8H3V9H8V8Z",
    fill: "#306DA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdetail);
export default __webpack_public_path__ + "static/media/rdetail.45c8feb7ac2a231a8cb059f3c03aaf72.svg";
export { ForwardRef as ReactComponent };